import { State } from 'app/redux';

export const getSettingsSalesOrder = (state: State) =>
  state.settings.salesOrder;
